import { useMemo } from 'react';

// 52-week GitHub-style activity grid
export function ActivityHeatmap({ data = {} }) {
  // data: { 'YYYY-MM-DD': score } — score 0-10 avg
  const weeks = useMemo(() => {
    const today  = new Date();
    const start  = new Date(today);
    start.setDate(start.getDate() - 364);
    // Align to Sunday
    start.setDate(start.getDate() - start.getDay());

    const grid = [];
    let week   = [];
    const d    = new Date(start);

    while (d <= today) {
      const key = d.toISOString().split('T')[0];
      week.push({ date: key, score: data[key] ?? null });
      if (week.length === 7) { grid.push(week); week = []; }
      d.setDate(d.getDate() + 1);
    }
    if (week.length) grid.push(week);
    return grid;
  }, [data]);

  const getColor = (score) => {
    if (score === null) return 'var(--border, #e8e6df)';
    if (score >= 8)  return '#3B6D11';
    if (score >= 6)  return '#5B9E1C';
    if (score >= 4)  return '#8DCC50';
    if (score >= 1)  return '#C5E89B';
    return 'var(--border, #e8e6df)';
  };

  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const days   = ['S','M','T','W','T','F','S'];

  return (
    <div style={{ overflowX: 'auto' }}>
      <div style={{ display: 'flex', gap: 4, alignItems: 'flex-start' }}>
        {/* Day labels */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 3, paddingTop: 18 }}>
          {days.map((d, i) => (
            <div key={i} style={{ height: 11, fontSize: 9, color: 'var(--text-faint, #a8a69f)', display: i % 2 === 1 ? 'block' : 'none' }}>
              {d}
            </div>
          ))}
        </div>

        {/* Grid */}
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', gap: 3 }}>
            {weeks.map((week, wi) => (
              <div key={wi} style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {week.map((day, di) => (
                  <div
                    key={di}
                    title={day.score !== null ? `${day.date}: avg ${day.score}/10` : day.date}
                    style={{
                      width: 11, height: 11, borderRadius: 2,
                      background: getColor(day.score),
                      transition: 'background 0.15s',
                      cursor: day.score !== null ? 'pointer' : 'default',
                    }}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Legend */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8, justifyContent: 'flex-end' }}>
        <span style={{ fontSize: 10, color: 'var(--text-faint)' }}>Less</span>
        {[null, 1, 4, 6, 8].map((s, i) => (
          <div key={i} style={{ width: 11, height: 11, borderRadius: 2, background: getColor(s) }} />
        ))}
        <span style={{ fontSize: 10, color: 'var(--text-faint)' }}>More</span>
      </div>
    </div>
  );
}

export default ActivityHeatmap;
